import configureStore from './configureStore'

export const { store, history, persistor } = configureStore(undefined)
